// File: frontend/src/components/people/PersonList.tsx
import React from "react";
import "./PersonList.css";
import { PersonModel } from "../../models/PersonModel";
import { PersonRow } from "./PersonRow";
// Sitewide pins: badge wrapper for the admin-pinned topic row
import { PinnedTopicWrap } from "../common/PinnedTopicWrap";
import { useTranslation } from "react-i18next";

interface PersonListProps {
  people: PersonModel[];
  selectedPersonId: number | null;
  onSelectPerson: (personId: number) => void;
  // Forwarded to each PersonRow for mobile pane switching
  onMobileNavigate?: () => void;
  // ID of the admin-pinned person (null = nothing pinned)
  pinnedPersonId?: number | null;
}

export const PersonList: React.FC<PersonListProps> = ({
  people,
  selectedPersonId,
  onSelectPerson,
  onMobileNavigate,
  pinnedPersonId = null,
}) => {
  const { t } = useTranslation();

  if (!people || people.length === 0) {
    return (
      <div className="person-list__empty">
        <p>{t("people_not_found", "Kişi bulunamadı.")}</p>
      </div>
    );
  }

  return (
    <div className="person-list">
      {people.map(person => (
        <PinnedTopicWrap key={person.id} pinned={person.id === pinnedPersonId}>
        <PersonRow
          person={person}
          isSelected={person.id === selectedPersonId}
          onSelect={() => onSelectPerson(person.id)}
          onMobileNavigate={onMobileNavigate}
        />
        </PinnedTopicWrap>
      ))}
    </div>
  );
};